import { Injectable } from '@angular/core';
import { ApiRequestService } from './api-request.service';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../models/api-response.model';
import { FolderModel } from './folder.model';
import { merge } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FolderService {
  private readonly resourceUrl = 'v1/folders';

  constructor(private api: ApiRequestService) {}

  public create(folder: FolderModel): Observable<ApiResponseModel<number>> {
    return this.api.makeRequestObservable('post', this.resourceUrl, folder);
  }

  public update(folder: FolderModel): Observable<{}> {
    return this.api.makeRequestObservable(
      'put',
      `${this.resourceUrl}/${folder.id}`,
      folder
    );
  }

  public delete(ids: number[]): Observable<{}> {
    return this.api.makeRequestObservable(
      'delete',
      `${this.resourceUrl}/${ids.join(',')}`
    );
  }

  public deleteMany(ids: number[]): Observable<{}> {
    const deletes = ids.map(id => this.api.makeRequestObservable(
      'delete', this.resourceUrl + `/${id}`
    ));
    return merge(...deletes);
  }

  find(id: number): Observable<ApiResponseModel<FolderModel>> {
    return this.api.makeRequestObservable('get', this.resourceUrl + `/${id}`);
  }
}
